<script>
    import { fade }          from 'svelte/transition'
    import ManualIntegration from './integrations/Manual.svelte'
    import ApiIntegration    from './integrations/Api.svelte'
    import PluginIntegration from './integrations/Plugins.svelte'
    import GDriveIntegration from './integrations/GDrive.svelte'

    export let domain
    export let place
    export let latest = false
    
    const active = place.connectors && place.connectors.find(i => i.active)
    let mode  = active ? active.kind : "email"
</script>
<style>
    .detail {
        background-color: white;
    }
</style>
<h2 class="ui header">Integração</h2>
<div class="ui left aligned vertical segment">
    <div class="ui toggle big checkbox">
        <input type="radio" bind:group={mode} value="email">
        <label>Manual</label>
    </div>
    {#if mode === "email"}
        <div transition:fade class="detail ui raised segments">
            <div class="ui segment">
                <p>Forneça os dados de contato</p>
            </div>
            <div class="ui basic segment">
                <ManualIntegration {domain} {place} {active} />
            </div>
        </div>
    {/if}
</div>
<div class="ui left aligned vertical segment">
    <div class="ui toggle big checkbox">
        <input type="radio" bind:group={mode} value="api">
        <label>Api</label>
    </div>
    {#if mode === "api"}
        <div transition:fade class="detail ui raised segments">
            <div class="ui segment">
                <p>Forneça a url para acesso ao sistema</p>
            </div>
            <div class="ui basic segment">
                <ApiIntegration {domain} {place} {active} />
            </div>
        </div>
    {/if}
</div>
<div class="ui left aligned vertical segment">
    <div class="ui toggle big checkbox">
        <input type="radio" bind:group={mode} value="gdrive-sheets">
        <label>Google Drive</label>
    </div>
    {#if mode === "gdrive-sheets"}
        <div transition:fade class="detail ui raised segments">
            <div class="ui segment">
            <i class="ui orange right ribbon label">experimental</i>
                <p>Forneça os dados de acesso</p>
            </div>
            <div class="ui basic segment">
                <GDriveIntegration {domain} {place} {active} />
            </div>
        </div>
    {/if}
</div>
<div class="ui left aligned vertical segment">
    <div class="ui toggle big checkbox">
        <input type="radio" bind:group={mode} value="plugin">
        <label>Plugin</label>
    </div>
    {#if mode === "plugin"}
        <div transition:fade class="detail ui raised segments">
            <div class="ui segment">
                <p>Escolha o plugin</p>
            </div>
            <div class="ui basic segment">
                <PluginIntegration {domain} {place} {active} />
            </div>
        </div>
    {/if}
</div>
<div class="ui left aligned vertical segment">
    <div class="ui toggle big checkbox disabled">
        <input type="radio" bind:group={mode} value="DB" disabled>
        <label>Banco de Dados</label>
    </div>
</div>
<div class="ui left aligned vertical segment">
    <div class="ui toggle big checkbox disabled">
        <input type="radio" bind:group={mode} value="ROBOT" disabled>
        <label>Robô</label>
    </div>
</div>
